import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';
import { TAnswersState } from '../../containers/FormContainer/types/internal';
import { getType } from './utils';
import { filter } from 'ramda';
import { getBannerSource } from '../getBannerSource';

export interface ITrackFormBaseEventProps {
  field: string;
  answersState: TAnswersState;
  deviceType: TDevice;
}

export interface ITrackFormEventProps extends ITrackFormBaseEventProps {
  action: string;
  label: string;
}
export const trackEvent = (props: ITrackFormEventProps) => {
  const { action, answersState, field, deviceType, label } = props;
  const type = getType(answersState, field);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action,
    label,
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'application_form',
      extra: {
        type,
        banner_location: getBannerSource(),
      },
    },
  });
};

export const trackPrevStepEvent = ({ answersState, field, deviceType }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'previous',
    action: 'Click',
    deviceType,
    field,
    answersState,
  });
};

export const trackBackToPageEvent = ({ answersState, field, deviceType }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'back_to_source',
    action: 'Click',
    deviceType,
    field,
    answersState,
  });
};

export interface ITrackClickEventProps extends ITrackFormBaseEventProps {
  isRequired: boolean;
  isDirty: boolean;
  value: string | null | undefined;
}

export const trackClickEvent = (props: ITrackClickEventProps) => {
  const { deviceType, field, answersState, isDirty, isRequired, value } = props;
  const requireLabel = isRequired ? 'isRequired' : 'notRequired';
  const defaultLabel = isDirty ? '' : 'default';
  const valueLabel = value ? value : '';

  trackEvent({
    label: filter(value => !!value, [requireLabel, defaultLabel, valueLabel]).join('/'),
    action: `Click_${field}`,
    deviceType,
    field,
    answersState,
  });
};

export const trackAddressFailEvent = ({ answersState, field, deviceType }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: '',
    action: 'fail',
    deviceType,
    field,
    answersState,
  });
};

export const trackCompleteButtonEvent = ({ answersState, field, deviceType }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'to_mortgage',
    action: 'Click',
    deviceType,
    field,
    answersState,
  });
};

export const trackFormSend = ({ answersState, field, deviceType }: ITrackFormBaseEventProps) => {
  trackEvent({
    label: 'Page',
    action: 'Send',
    deviceType,
    field,
    answersState,
  });
};
